import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';

class ModalVistaRegimental extends ReactComponent {
    magistradosSelecionados = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            magistradosSelecionados: observable,
            registro: computed,
            opcoesMagistrados: computed,
            callbackAutoCompleteMagistrado: action,
            handleDelete: action,
            exibirAutoComplete: computed
        });

        this.createReaction(
            reaction(
                () => this.observableProps.aberto,
                () => (this.magistradosSelecionados = [])
            )
        );
    }

    get registro() {
        return this.observableProps.registro;
    }

    get opcoesMagistrados() {
        if (this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            return this.dominioStore.opcoesMagistradosComposicao(this.registro);
        }
        return this.dominioStore.opcoesMagistradosAutoComplete(this.registro);
    }

    callbackAutoCompleteMagistrado = (option) => {
        if (option && option.valor) {
            let adicionado = this.magistradosSelecionados.findIndex(
                (magistrado) => magistrado.sigla === option.valor.sigla
            );
            if (adicionado > -1) {
                this.mensagemStore.abrirMensagemAlerta('Magistrado já adicionado no pedido de vista.');
            } else {
                this.magistradosSelecionados.push(option.valor);
            }
        }
    };

    handleDelete(sigla) {
        let indexMagistrado = this.magistradosSelecionados.findIndex((magistrado) => magistrado.sigla === sigla);
        this.magistradosSelecionados.splice(indexMagistrado, 1);
    }

    callbackOk = async () => {
        this.observableProps.callbackOk(this.magistradosSelecionados);
    };

    get exibirAutoComplete() {
        return (
            (this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE) ||
            !this.magistradosSelecionados ||
            this.magistradosSelecionados.length === 0
        );
    }

    render() {
        if (!this.observableProps.aberto) {
            return null;
        }

        return (
            <Dialog
                open={this.observableProps.aberto}
                onClose={this.observableProps.callbackCancel}
                maxWidth="md"
            >
                <DialogTitle>
                    Vista Regimental{this.registro ? ' do Processo ' + this.registro.processo.numeroCompleto : ''}
                </DialogTitle>
                <DialogContent style={{ width: '600px', height: '200px' }}>
                    {this.exibirAutoComplete && (
                        <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                            <AutoComplete
                                apresentarTextoSecundario
                                options={this.opcoesMagistrados}
                                onChange={this.callbackAutoCompleteMagistrado}
                                label="Selecione..."
                            />
                        </div>
                    )}
                    {this.magistradosSelecionados &&
                        this.magistradosSelecionados.map((magistrado) => {
                            return (
                                <Chip
                                    label={magistrado.sigla}
                                    onDelete={this.handleDelete.bind(this, magistrado.sigla)}
                                    key={this.nextKey}
                                />
                            );
                        })}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={this.observableProps.callbackCancel}
                        color="secondary"
                    >
                        Cancelar
                    </Button>
                    <Tooltip
                        title={this.magistradosSelecionados.length > 0 ? '' : 'Selecione ao menos um(a) magistrado(a)'}
                    >
                        <div>
                            <Button
                                onClick={this.callbackOk}
                                color="primary"
                                disabled={this.magistradosSelecionados.length > 0 ? false : true}
                            >
                                Ok
                            </Button>
                        </div>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ModalVistaRegimental));
